import {FileLikeObject} from 'ng2-file-upload';

export class CreateMessageChangeEvent {
    content: string;
    attachments: FileLikeObject[];


    constructor(content: string, attachments: FileLikeObject[]) {
        this.content = content;
        this.attachments = attachments;
    }
}